import { FilterBuilder } from '../Types';

const priceBuilder: FilterBuilder = (params, context) => {
  if (context?.withoutPrice) {
    return '';
  }

  const queryKey = context?.withDynamicMinimumPrice ? 'minPrice' : 'priceEUR';
  let priceMinFilter = '';
  let priceMaxFilter = '';

  if (params.priceMin) {
    priceMinFilter = `${queryKey}>=${Math.floor(params.priceMin / 100)}`;
  }

  if (params.priceMax || (context?.allowZeroPrice && params.priceMax === 0)) {
    priceMaxFilter = `${queryKey}<=${Math.ceil(params.priceMax / 100)}`;
  }

  return [priceMinFilter, priceMaxFilter].filter(Boolean).join(' AND ');
};

export { priceBuilder };
